const unreachable = (s: string) => {
  /* eslint-disable-next-line no-console */
  console.log('recevied tag type is unknonw', 'tag', s)

  throw new Error('received tag type is unknonw')
}

export type ContainerStatus = 'full' | 'empty'

export const convertContainerStatus = (status: string): ContainerStatus => {
  switch (status) {
    case 'full':
      return 'full'
    case 'empty':
      return 'empty'
    default:
      unreachable(status)
  }
}

export enum Tag {
  NotFinished = 'not_finished',
  Pickup = 'pickup',
  Delivery = 'delivery',
  Urgent = 'urgent_order',
  VIP = 'vip_user',
}

export type TagsType = Tag.NotFinished | Tag.Pickup | Tag.Delivery | Tag.Urgent | Tag.VIP

export const convertToTag = (tagsType: string): TagsType => {
  switch (tagsType) {
    case Tag.NotFinished:
    case Tag.Pickup:
    case Tag.Delivery:
    case Tag.Urgent:
    case Tag.VIP:
      break
    default:
      unreachable(tagsType)
  }

  return tagsType as TagsType
}

export const convertToTags = (list: string[]): TagsType[] => list?.map(convertToTag)

export type Cargo = {
  id: string
  orderNumber: number
  containers: Container[]
  tags: Tag[]
  comments: Commets
  date: Date
  items: Item[]
  product?: string
}

export type Container = {
  id: string
  name: string
  status: ContainerStatus
  sealNumber: string
}

export type ContainerType = {
  id: string
  name: string
  slug: string
  summary: string
  type: string
  amount: ContaienrsAmount
}

export type EmptyContainer = {
  id: string
  containerTypeId: string
  name: string
  deliveryType: Tag
  labelled: boolean
  labelNumber: string
}

export type EmptyContainers = {
  containerTypeId: string
  emptyContainers: EmptyContainer[]
}

export type ContaienrsAmount = {
  total: number
  used: number
}

export type Commets = {
  storekeeperComment: string
  supportComment: string
}

export type Item = {
  name: string
  count: number
}

export type WarehouseFilters = {
  interval?: [Date, Date]
  products?: string[]
  orderNumber?: number
  containerSeal?: number
  deliveryType?: number
  courierWarehouseId?: number
}

export type WarehouseArgs = {
  id: number
  name: string
}
